// 时间格式化
const DATE_TIME_FORMAT_STRING = 'YYYY-MM-DD HH:mm:ss';
const DATE_FORMAT_STRING = 'YYYY-MM-DD';
const TIME_FORMAT_STRING = 'HH:mm:ss';
const HOUR_MIN_FORMAT_STRING = 'HH:mm';
const SLASH_DATE_TIME_FORMAT_STRING = 'YYYY/MM/DD HH:mm:ss';
const MOMENT_FOREVER_DAYS = '10000000000000'

// 数字格式化
const MONEY_FORMAT = '0,0.00';
const INTEGER_FORMAT = '0,0';
const PERCENTAGE_FORMAT = '0.00%';


const POLICY_EMPTY_FILTERED_TAGS = {
  "org_list": [],
  "policy_class": [],
  "theme_list":[],
  "time_range": [],
  "domain_list": [],
  "large_policy_class_list":[],
  "province_list":[]
}

const SGERI_ORG_SYNONYM = [
  {
    name:'国务院',
    synonym:[
      '国务院','国务院办公厅'
    ]
  },
  {
    name:'国务院办公厅',
    synonym:[
      '国务院','国务院办公厅'
    ]
  },
  {
    name:'发改委',
    synonym:[
      '发改委','发展改革委','国家发展改革委','发展改革委网站','发展改革委办公厅','国家发展改革委办公厅','国家发展改革委网站','发展改革委等','国家发展改革委等'
    ]
  },
  {
    name:'发展改革委',
    synonym:[
      '发改委','发展改革委','国家发展改革委','发展改革委网站','发展改革委办公厅','国家发展改革委办公厅','国家发展改革委网站','发展改革委等','国家发展改革委等'
    ]
  },
  {
    name:'国家发展改革委',
    synonym:[
      '发改委','发展改革委','国家发展改革委','发展改革委网站','发展改革委办公厅','国家发展改革委办公厅','国家发展改革委网站','发展改革委等','国家发展改革委等'
    ]
  },
  {
    name:'能源局',
    synonym:[
      '能源局','国家能源局','能源局综合司','国家能源局综合司','能源局网站','国家能源局网站'
    ]
  },
  {
    name:'国家能源局',
    synonym:[
      '能源局','国家能源局','能源局综合司','国家能源局综合司','能源局网站','国家能源局网站'
    ]
  },
  {
    name:'国资委',
    synonym:[
      '国资委','国务院国资委','国资委办公厅','国资委网站','国务院国资委办公厅','国务院国资委网站'
    ]
  },
  {
    name:'国务院国资委',
    synonym:[
      '国资委','国务院国资委','国资委办公厅','国资委网站','国务院国资委办公厅','国务院国资委网站'
    ]
  },
  {
    name:'工信部',
    synonym:[
      '工信部','工业和信息化部','工业和信息化部办公厅','工业和信息化部网站','中华人民共和国工业和信息化部'
    ]
  },
  {
    name:'工业和信息化部',
    synonym:[
      '工信部','工业和信息化部','工业和信息化部办公厅','工业和信息化部网站','中华人民共和国工业和信息化部'
    ]
  },
  {
    name:'生态环境部',
    synonym:[
      '生态环境部','生态环境部办公厅','生态环境部网站','中华人民共和国生态环境部'
    ]
  },

]

const SPECIFIC_ORG_LIST = [
  '能源局','国家能源局','能源局综合司',
  '国资委','国务院国资委','国资委办公厅','国资委网站',
  // '发改委','发展改革委','国家发展改革委',
  // '工信部','工业和信息化部','工业和信息化部办公厅','工业和信息化部网站',
  // '国务院','国务院办公厅',
]

const SPECIFIC_KEYWORD_LIST = [
  '能源','电力','绿色能源','新能源','双碳','电力改革','电力市场'
]

export {
  DATE_TIME_FORMAT_STRING,
  DATE_FORMAT_STRING,
  TIME_FORMAT_STRING,
  HOUR_MIN_FORMAT_STRING,
  SLASH_DATE_TIME_FORMAT_STRING,
  MOMENT_FOREVER_DAYS,
  MONEY_FORMAT,
  INTEGER_FORMAT,
  PERCENTAGE_FORMAT,
  SGERI_ORG_SYNONYM, // 国网能源院重点关注机构近义词映射表
  SPECIFIC_ORG_LIST, // 国网能源院重点关注机构列表
  SPECIFIC_KEYWORD_LIST, // 国网能源院重点关注关键词列表
  POLICY_EMPTY_FILTERED_TAGS, // 政策空过滤标签
};
